/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IImageListViewProps } from '@msdyn365-commerce-modules/image-list';

/**
 * Render the thumbnail item images.
 * @param props - The image list view props.
 * @returns Return HTML having IImageListViewProps props with image List.
 */
export const imageListView = (props: IImageListViewProps): JSX.Element => {
    const { imageList, imageListContainer, imageListHeading, imageListItem, imageListItems, imageListItemAnchorTag } = props;
    return (
        <Module {...imageList}>
            {imageListHeading}
            <Node {...imageListContainer}>
                {imageListItems?.map(item => {
                    let indexKey: string;

                    if (item.image) {
                        const image = (item.image as unknown) as Msdyn365.Image;
                        indexKey = image.props.src as string;
                    } else {
                        const text = (item.text as unknown) as Msdyn365.RichTextComponent;
                        indexKey = text.props.text as string;
                    }
                    return (
                        <Node {...imageListItem} key={indexKey}>
                            {item.image && (
                                <Node
                                    {...imageListItemAnchorTag}
                                    href={item.link}
                                    altText={item.linkAltText}
                                    aria-label={item.linkAriaLabel}
                                    className={imageListItemAnchorTag.className}
                                    target={item.linkOpenInNewTab ? '_blank' : undefined}
                                >
                                    {item.image}
                                    {/* @CUSTOM: Move text inside link */}
                                    {item.text}
                                </Node>
                            )}
                        </Node>
                    );
                })}
            </Node>
        </Module>
    );
};

export default imageListView;
